import { urls } from "../constants";
import { Post, Get, Delete } from "../fetch";
export async function getUserApplicationsId({
  userId
}) {
  return Get(`${urls.identity.applications.v1}/${userId}/apps`);
}
export async function getUsersApplicationsId({
  userIds
}) {
  return Get(`${urls.identity.applications.v1}/users-apps`, {
    userIds: userIds.join(',')
  });
}
export async function getTenantsApplications() {
  return Get(urls.applications.tenant.v1);
}
export async function getApplicationsData({
  appIds,
  includeFreeAccess = true
}) {
  return Get(urls.applications.v1, {
    ids: appIds.join(','),
    _includeFreeAccess: includeFreeAccess
  });
}
export async function assignUserToApplications(body) {
  return Post(`${urls.identity.applications.v1}/apps-user`, body);
}
export async function unassignUserFromApplications(body) {
  return Delete(`${urls.identity.applications.v1}/user-apps`, body);
}
export async function getUsersOfApplications({
  appIds
}) {
  return Get(`${urls.identity.applications.v1}/apps-users`, {
    appIds: appIds.join(',')
  });
}